// GridSlider.js
import React from 'react';
import Slider from 'react-slick';
import './Slider.css';
import './Slider-theme.css';

function GridSlider({ images }) {
  const settings = {
    dots: false,
    autoplaySpeed: 5000,  // Change every 5 seconds
    autoplay: true,
    infinite: true,
    speed: 700,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <div className="flex justify-center items-center">
              <img
                src={image}
                alt={`Slide Image ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default GridSlider;
